module.exports = __webpack_public_path__ + "img/num_28.73008541.png";